module.exports = __webpack_public_path__ + "static/media/2_logo.ae1cf945.jpg";